import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Form } from 'semantic-ui-react'
import ParticipantsTable from '../components/participants_table';
import UserPlanPermissionTable from '../components/user_plan_permission_table'
import { findObjectByKeyValue } from '../helpers';

class CreatePlanModal extends Component {
  constructor(props){
    super(props);

    this.state = {
      planName: "",
      invalidPlanName: false,
      participants: [],
      permissionModal: false,
      permissions: props.permissions ? props.permissions : [],
      templateId: 1,
    }

  }

  onChangePlanName = (value) => {
    this.setState({
      planName: value,
    })
  }

  onCreatePlan = () => {
    if(this.state.planName.length === 0) {
      this.setState({
        invalidPlanName: true,
      })
      return
    }

    const plan = {}
    plan.name = this.state.planName
    plan.plan_permissions = {}
    this.state.permissions.forEach( p => {
      plan.plan_permissions[p.user_id] = { user_id: p.user_id, can_read: p.can_read, can_update: p.can_update  }
    })


    if( this.props.templateOptions ){
      this.props.onCreatePlan(this.state.templateId, plan, this.state.participants)
    } else {
      this.props.onCreatePlan(plan, this.state.participants)
    }
  }

  updateParticipants = (participants) => {
    this.setState({
      participants: participants
    })
  }

  openPermissionModal = () => {
    this.setState({ permissionModal: true })
  }

  closePermissionModal = (e, permissions) => {
    e.stopPropagation();
    const newState = {}
    newState.permissionModal = false
    if(permissions){ newState.permissions = permissions }
    return this.setState(newState)
  }

  onTemplateChange = (e, obj) => {
    const { value: templateId } = obj;
    const template = findObjectByKeyValue(this.props.templates, templateId, 'id');
    const permissions = template ? template.plan_permissions : [];
    this.setState({ templateId, permissions });
  }

  render() {
    const { create_a_plan, create_plan, participants, labelText, placeholderText,
            template_name, enter_plan_name } = this.props.translations
    return (
      <Modal trigger={ this.props.trigger } size={ 'tiny' } open={ this.props.shown }>
        <Modal.Header>{create_a_plan}</Modal.Header>
        <Modal.Content>
          <Form>
            { this.props.templateOptions ?
                <Form.Select fluid
                  label={ labelText } options={this.props.templateOptions}
                  placeholder={ placeholderText }
                  onChange={this.onTemplateChange}
                  defaultValue={this.state.templateId}/>
              :
                <Form.Input fluid label={template_name} value={ this.props.template } />
            }

            <Form.Input fluid label={enter_plan_name} placeholder={enter_plan_name} onChange={ (target, { value }) => this.onChangePlanName(value) } error={ this.state.invalidPlanName }/>
            <div className="field">
              <label>{participants}</label>
              <ParticipantsTable
                participants={this.state.participants}
                updateParticipants={this.updateParticipants}
                translations={this.props.translations}
                isAdmin={this.props.isAdmin}
              />
              { this.props.isAdmin &&
                <React.Fragment>
                  <span className="form-modal-link" onClick={this.openPermissionModal}>
                    <b>{"Permissions"}</b>
                  </span>
                  { this.state.permissionModal &&
                    <UserPlanPermissionTable
                      translations={this.props.translations}
                      plans={this.state.plans}
                      open={this.state.permissionModal}
                      close={this.closePermissionModal}
                      filter={this.state.userPlanPermissionFilters}
                      permissions={this.state.permissions}
                      formMode={true}
                    />
                  }
                </React.Fragment>
              }
            </div>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color='teal'
            content={create_plan}
            fluid
            size='medium'
            className="new-plan-button"
            onClick={this.onCreatePlan}
          />
        </Modal.Actions>
        <i className="delete icon" onClick={ this.props.onClose }></i>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreatePlanModal)



// WEBPACK FOOTER //
// ./src/components/create_plan_modal.js